import { useState } from "react";
import { Camera, Sparkle } from "@phosphor-icons/react";
import ReceiptScanDialog from "@/components/ReceiptScanDialog";

/**
 * Kompakter Beleg-Foto-Button für Dashboard (Admin + Staff).
 * Optimiert für Larissa: Ein Klick → Handy-Kamera direkt auf, Foto, KI verbucht.
 */
export default function QuickReceiptScan() {
  const [open, setOpen] = useState(false);
  const [categories] = useState([
    "Lebensmittel","Reinigung","Reparaturen","Energie","Verbrauchsmaterial",
    "Marketing","Versicherung","Mobiliar","Mitarbeiter","Equipment",
    "Waschen","Trocknen","Gratis Espresso","Sonstiges",
  ]);

  return (
    <>
      <button
        onClick={()=>setOpen(true)}
        data-testid="dash-btn-scan-receipt"
        className="group relative rounded-2xl border-2 border-dashed border-indigo-300 bg-gradient-to-br from-indigo-50 to-purple-50 hover:from-indigo-100 hover:to-purple-100 transition p-4 text-left w-full flex items-center gap-3">
        <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-indigo-600 to-purple-600 flex items-center justify-center flex-shrink-0 shadow-sm">
          <Camera size={20} weight="fill" color="white"/>
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-bold text-slate-900 flex items-center gap-1.5" style={{fontFamily:"'Work Sans',sans-serif"}}>
            Beleg fotografieren
            <Sparkle size={14} weight="fill" className="text-indigo-600"/>
          </div>
          <div className="text-xs text-slate-600 mt-0.5">Kamera öffnen · KI erkennt Datum, Betrag & MwSt automatisch</div>
        </div>
      </button>
      {open && <ReceiptScanDialog categories={categories} onClose={()=>setOpen(false)} onSaved={()=>setOpen(false)}/>}
    </>
  );
}
